var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import api from "../../utils/api";

class Captcha extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    const { refresh } = this.props;

    refresh(this.refresh.bind(this));
    this.state = { svg: '', id: '', remoteUnreachable: false };
  }

  componentDidMount() {
    this.refresh();
  }

  onChange(e) {
    const { onChange } = this.props;
    onChange({ text: e.target.value, id: this.state.id });
  }

  async refresh() {
    const { remote } = this.props;
    const url = remote ? 'remotecaptcha' : 'captcha';
    try {
      const response = await api.get(url);
      this.setState(response.json);
    } catch (ex) {
      if (remote) {
        this.setState({ remoteUnreachable: true });
      }
    }
  }

  render() {
    const { value } = this.props;
    const { svg, remoteUnreachable } = this.state;

    if (!remoteUnreachable) {
      return /*#__PURE__*/(
        _jsx("div", { className: "captcha" }, void 0, /*#__PURE__*/
        _jsx("div", { dangerouslySetInnerHTML: { __html: svg } }), /*#__PURE__*/
        _jsx("input", { className: "form-control", onChange: this.onChange, value: value.text })
        ));

    }
    return /*#__PURE__*/(
      _jsx("div", { className: "alert-danger" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle" }), "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Remote Server Unreachable"), "."
      ));

  }
}

Captcha.defaultProps = {
  value: { text: '', id: '' },
  refresh: () => {},
  remote: false
};








export default Captcha;